"use client";
import { useEffect, useState } from "react";

const ADDRESS_MAPS = [
  {
    key: "east",
    label: "East Sikkim",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3210.192084406187!2d88.51195137490645!3d27.238680346007285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e6a1c3e1baaaab%3A0x6e38bf86f7e3420b!2sMedhavi%20Skills%20University%2C%20Sikkim!5e1!3m2!1sen!2sin!4v1767941551997!5m2!1sen!2sin",
  },
  {
    key: "west",
    label: "West Sikkim",
    iframe:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3209.7412226266897!2d88.24171147490695!3d27.254308045328372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e6832eeb4827b7%3A0xd5a6c3edc87e837b!2sMedhavi%20Skills%20University%2C%20Bermiok%20Campus!5e1!3m2!1sen!2sin!4v1767941445074!5m2!1sen!2sin",
  },
];

export default function FooterAddress() {
  const [open, setOpen] = useState(false);
  const [activeAddress, setActiveAddress] = useState(null);

  // Close modal on ESC
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, []);

  return (
    <>
      {/* Inline campus list */}
      <div className="flex flex-wrap items-center gap-2 text-white">
        {ADDRESS_MAPS.map((addr, index) => (
          <span key={addr.key} className="relative group">
            <span
              onClick={() => {
                setActiveAddress(addr);
                setOpen(true);
              }}
              className="footer-link underline cursor-pointer"
            >
              {addr.label}
            </span>

            {/* Separator */}
            {index < ADDRESS_MAPS.length - 1 && (
              <span className="mx-1">|</span>
            )}

            {/* Tooltip */}
            <span
              className="
                absolute left-1/2 -translate-x-1/2 top-full mt-2
                bg-[#FC9D00] text-white text-xs px-3 py-1 rounded
                opacity-0 group-hover:opacity-100 transition
                whitespace-nowrap z-50
              "
            >
              Click to view location
            </span>
          </span>
        ))}
      </div>

      {/* Modal */}
      {open && activeAddress && (
        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center top-10"
          onClick={() => setOpen(false)}
        >
          <div
            className="bg-white rounded-lg w-[90%] md:w-[700px] relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setOpen(false)}
              className="
                absolute  right-3 z-50
                w-9 h-9 flex items-center justify-center
                rounded-full bg-black/80 text-white
                hover:bg-black transition
                text-lg font-bold
              "
              aria-label="Close map"
            >
              ✕
            </button>

            <h3 className="absolute z-50 p-2
                flex items-center justify-center
                 bg-black/80 text-white
                hover:bg-black transition
                text-lg font-bold">
              {activeAddress.label} Campus
            </h3>

            <iframe
              src={activeAddress.iframe}
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      )}
    </>
  );
}
